import { render, staticRenderFns } from "./MenuItemNumber.vue?vue&type=template&id=610da986"
import script from "./MenuItemNumber.vue?vue&type=script&lang=js"
export * from "./MenuItemNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports